import { Order, OrderLeg, OrderStrategyType } from '@tradingblock/types';

/**
 * Returns the strategy type used when placing/finalizing the order.
 * Preview maps this to API {@link OrderStrategyType} values in `useOrderPreviewOrder`.
 */
export function resolveStrategyTypeForPlacement(order: Order<OrderLeg>): OrderStrategyType | undefined {
  return order.StrategyType;
}
